import React, { useState, useEffect } from "react";
import _ from "lodash";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal } from "react-bootstrap";
import "../../pages/_Components/ReactBeautifulDnd.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import SwalMessage from "../_Components/SwalMessage";
import ApiRegion from "../../../core/api/api.region";

const ChangeOrderRegion = ({ showModalRegionOrder, setShowModalRegionOrder }) => {
  const [Regions, setRegions] = useState([]);

  // Fetch all services
  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const region = await ApiRegion.getAllRegionsByActiveAmusements({ regionId: null });
        setRegions(region);
      } catch (error) {
      }
    };

    fetchGroups();
  }, []);
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const updatedRegions = Array.from(Regions);
    const [reorderedItem] = updatedRegions.splice(result.source.index, 1);
    updatedRegions.splice(result.destination.index, 0, reorderedItem);
    setRegions(updatedRegions);
  };
  const handleClose = () => {
    setShowModalRegionOrder(false);
  };
  const sendSortedRegions = async () => {
    try {
      // اطلاعات مورد نیاز برای ارسال به سرور
      const dataToSend = {
        Regions: Regions.map((item) => ({ id: item.id, name: item.name, type: item.type })),
      };
      // ارسال درخواست به سرور
      const response = await ApiRegion.changeOrderRegions(dataToSend);
      SwalMessage({ title: response.message, iSsuccess: true });
      //setShowModalRegionOrder(false);
    } catch (error) {
    }
  };

  return (
    <div>
      <div className="card-body pt-3 pb-0">
        {/* Start Modal */}
        <Modal centered size="md" show={showModalRegionOrder} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>ترتیب قرارگیری شهرها</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <ul className="sortable-list" {...provided.droppableProps} ref={provided.innerRef}>
                    {Regions.map((item, index) => (
                      <Draggable key={index} draggableId={index.toString()} index={index}>
                        {(provided) => (
                          <li
                            className="sortable-item"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <span>{item.name}</span>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={sendSortedRegions}>
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};
export default ChangeOrderRegion;
